import { createSlice } from '@reduxjs/toolkit';
import { AssetAllocationState } from './assetAllocationTypes';
import {
  allocateAsset,
  fetchAllAllocations,
  fetchAllocationById,
  updateAllocationStatus,
  deleteAllocation,
  updateAllocation,
  fetchAllocatedAssetsByEmployeeId
} from './assetAllocationActions';

const initialState: AssetAllocationState = {
  assetAllocations: [],
  assetAllocationsByEmployee: [],
  selectedAllocation: undefined,
  loading: false,
  Deleteloading: false,
  error: undefined,
};

const assetAllocationSlice = createSlice({
  name: 'assetAllocation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Allocate Asset
      .addCase(allocateAsset.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(allocateAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.assetAllocations.push(action.payload);
      })
      .addCase(allocateAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Allocations
      .addCase(fetchAllAllocations.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllAllocations.fulfilled, (state, action) => {
        state.loading = false;
        state.assetAllocations = action.payload.data;
      })
      .addCase(fetchAllAllocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Allocation by ID
      .addCase(fetchAllocationById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllocationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAllocation = action.payload;
      })
      .addCase(fetchAllocationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAllocatedAssetsByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllocatedAssetsByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.assetAllocationsByEmployee = action.payload.data; 
      })
      .addCase(fetchAllocatedAssetsByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Allocation Status
      .addCase(updateAllocationStatus.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateAllocationStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.assetAllocations.findIndex(allocation => allocation.id === action.payload.id);
        if (index !== -1) {
          state.assetAllocations[index] = action.payload;
        }
      })
      .addCase(updateAllocationStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Asset Allocation (New Case)
      .addCase(updateAllocation.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateAllocation.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.assetAllocations.findIndex(allocation => allocation.id === action.payload.id);
        if (index !== -1) {
          state.assetAllocations[index] = action.payload;
        }
      })
      .addCase(updateAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Allocation
      .addCase(deleteAllocation.pending, (state) => {
        state.Deleteloading = true;
        state.error = undefined;
      })
      .addCase(deleteAllocation.fulfilled, (state, action) => {
        state.Deleteloading = false;
        state.assetAllocations = state.assetAllocations.filter((allocation: any) => allocation.id !== action.payload.id);
      })
      .addCase(deleteAllocation.rejected, (state, action) => {
        state.Deleteloading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetAllocationSlice.reducer;
